import { render } from "./ClaimEvidence.vue?vue&type=template&id=29d78764&scoped=true"
import script from "./ClaimEvidence.vue?vue&type=script&lang=js"
export * from "./ClaimEvidence.vue?vue&type=script&lang=js"

import "./ClaimEvidence.vue?vue&type=style&index=0&id=29d78764&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29d78764"]])

export default __exports__